import { Component, effect, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { LfwRouterService } from '../../route/lfw-router.service';
import { InfoService } from '../../shared/services/info.service';
import { OfflineFormsClient, OfflineOrders } from '../offline-orders/offline-forms.client';
import { OfflineOrderViewComponent } from '../offline-orders/offline-order-view/offline-order-view.component';

@Component({
  selector: 'lfw-offline-orders',
  templateUrl: './offline-orders.component.html',
  styleUrls: ['./offline-orders.component.css'],
  imports: [OfflineOrderViewComponent]
})
export class OfflineOrdersComponent {
  private readonly offlineFormsClient = inject(OfflineFormsClient);
  private readonly routerService = inject(LfwRouterService);
  private readonly infoService = inject(InfoService);

  private readonly hasOfflineOrders = toSignal(this.offlineFormsClient.onlyOfflineOrders$);

  readonly offlineOrders$: Observable<OfflineOrders> = this.offlineFormsClient.onlyOfflineOrders$;

  constructor() {
    effect(() => {
      const hasOfflineOrders = this.hasOfflineOrders();
      const isLoaded = this.offlineFormsClient.isLoaded();

      if (!isLoaded || hasOfflineOrders === undefined) {
        return;
      }

      const count = Object.keys(hasOfflineOrders).length;
      if (count === 0) {
        this.routerService.navigateToOrdersRoot();
        return;
      }

      this.infoService.setLoadedItems(count);
    });
  }
}
